export default __webpack_public_path__ + "static/media/messages_2.fd750fbf.png";